import PropTypes from 'prop-types';
import React from 'react';
import HotelCard from './HotelCard';

class HotelList extends React.Component {
  render() {
    if (!this.props.hotels) {
      return <div className="row">No hotels returned.</div>;
    }
    const cards = [];
    this.props.hotels.forEach(hotel => {
      cards.push(
        <HotelCard
          key={hotel.id}
          hotel={hotel}
          requestHotelClaim={this.props.requestHotelClaim}
          viewHotel={this.props.viewHotel}
          managed={this.props.managed}
          readOnly={this.props.readOnly}
          isSearchHotel={this.props.isSearchHotel}
        />
      );
    });
    return <div className="row">{cards}</div>;
  }
}
HotelList.propTypes = {
  hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
  managed: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  requestHotelClaim: PropTypes.func.isRequired,
  viewHotel: PropTypes.func.isRequired,
};
export default HotelList;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelList.js